import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { F as FilterDropdown } from './FilterDropdown-Dj_Qzi00.js';

/**
 * @deprecated
 * Please use the FilterDropdown with `hideLabel` and `mobileFullScreen` both set to true
 * @returns a FilterDropdown on desktop and FilterRadioGroup on mobile
 */
const FilterRadioGroup = ({
  radioGroupName = '',
  radioGroupLabel = '',
  ...restProps
}) => /*#__PURE__*/React.createElement(FilterDropdown, _extends({
  hideLabel: true // copied from ./FilterRadioGroupBody.tsx
}, restProps, {
  mobileFullScreen: true,
  name: radioGroupName,
  label: radioGroupLabel
}));

export { FilterRadioGroup as F };
//# sourceMappingURL=FilterRadioGroup-BYPwizGs.js.map
